module.exports = __webpack_public_path__ + "TiemposFine-LightItalic.svg?e82a076451947b67be1dea40ed178c71";